"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _occasion = _interopRequireDefault(require("occasion"));
var _button = _interopRequireDefault(require("../../../core/button"));
var _pdfButton = _interopRequireDefault(require("../../../core/pdf-button"));
var _modal = _interopRequireDefault(require("../../../core/modal"));
var _input = _interopRequireDefault(require("../../../core/input"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const initialState = {
  selectingDayToDownload: false,
  selectedDayID: null,
  generatingPDF: false
};
class PDFRunningOrder extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", initialState);
    _defineProperty(this, "_onSelectDay", selectedDayID => {
      this.setState({
        selectedDayID
      });
    });
    _defineProperty(this, "_onBeginDownload", () => {
      this.setState({
        selectingDayToDownload: true
      });
    });
    _defineProperty(this, "_onCloseCancel", () => {
      this.setState(initialState);
    });
    // this automatically closes the modal, but delays to allow some time for downloading
    // ideally want to know when generating is finished, but this is a compromise.
    _defineProperty(this, "_onGeneratingPDF", () => {
      this.setState({
        generatingPDF: true
      });
      setTimeout(() => {
        this._onCloseCancel();
      }, 2000);
    });
  }
  render() {
    const modalButtons = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onCloseCancel
    }, "Close"), ' ', /*#__PURE__*/_react.default.createElement(_pdfButton.default, {
      name: "running-order",
      args: {
        useColour: true,
        competitionSlug: this.props.competitionSlug,
        yearID: this.props.yearID,
        dayID: this.state.selectedDayID
      },
      disabled: this.state.generatingPDF,
      onClick: this._onGeneratingPDF,
      type: "primary"
    }, "Download PDF"));
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      style: {
        marginBottom: 8
      },
      onClick: this._onBeginDownload,
      type: "primary",
      block: true
    }, "Download Running Order as PDF"), !this.state.selectingDayToDownload ? null : /*#__PURE__*/_react.default.createElement(_modal.default, {
      title: "Download Running Order to PDF",
      buttons: modalButtons,
      onClose: this._onCloseCancel
    }, /*#__PURE__*/_react.default.createElement("div", null, !this.props.competitionDays || !this.props.competitionDays.length ? null : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", {
      style: {
        marginTop: '12px'
      },
      className: "lead"
    }, "Select Day to Download"), this.props.competitionDays.map(day => /*#__PURE__*/_react.default.createElement(_input.default, {
      key: day.id,
      type: "Radio",
      name: "exportDay",
      checked: this.state.selectedDayID === day.id,
      label: (0, _occasion.default)(day.dayDate, 'dddd, DD MMM YYYY'),
      onChange: () => this._onSelectDay(day.id)
    })), /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "Radio",
      name: "exportDay",
      checked: this.state.selectedDayID === null,
      label: "All",
      onChange: () => this._onSelectDay(null)
    })))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _default = exports.default = PDFRunningOrder;